import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { LayoutComponent } from './layout.component';
import { VerticalComponent } from './vertical/vertical.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { LaddaModule } from "angular2-ladda";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
import { BreadcrumbService } from '../shared/breadcrumb/breadcrumb.service';
import { BreadcrumbComponent } from '../shared/breadcrumb/breadcrumb.component';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { HttpService } from '../shared/http.service';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

export function createNgxLoader(ngx: NgxPermissionsService, httpService: HttpService) {
  return () => {
    let menus = httpService.menus();
    if (menus && menus.length != 0) {
      let filteredMenus = menus.filter((x: { AccessTypeId: null; }) => x.AccessTypeId != null);
      let permissions: any[] = filteredMenus.map((x: { Id: any; }) => x.Id);
      return ngx.loadPermissions(permissions);
    }
  };
}


@NgModule({
  declarations: [
    LayoutComponent,
    VerticalComponent,
    TopbarComponent,
    SidebarComponent,
    FooterComponent,
    BreadcrumbComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbNavModule,
    SimplebarAngularModule,
    NgxPermissionsModule.forRoot(),
    LaddaModule.forRoot({
      style: "expand-right",
      spinnerSize: 30,
      spinnerColor: "white",
      spinnerLines: 12,
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBorderRadius: "4px",
      primaryColour: "#d7e7db",
      secondaryColour: "#57a170",
    }),
    LoadingBarHttpClientModule
  ],
  providers: [
    BreadcrumbService,
    NgxPermissionsService,
    {
      provide: APP_INITIALIZER,
      useFactory: createNgxLoader,
      deps: [NgxPermissionsService, HttpService],
      multi: true
    },
  ]
})
export class LayoutsModule { }
